/**
 * The date patterns an operator picks from before writing one by hand.
 *
 * Declared here rather than on the `brand.dateFormat` definition because they
 * are a property of the **pattern vocabulary**, not of one setting: a preset's
 * label is a rendered sample rather than a translated string, so a
 * `SettingSelectOption.labelKey` would have nothing true to hold, and restating
 * the list per definition is the duplication U3 exists to prevent.
 *
 * Every entry must satisfy `DatePatternSchema` — asserted in its spec, so a
 * preset can never be an example of something the schema refuses.
 */
export const DATE_PATTERN_PRESETS = [
  'DD/MM/YYYY',
  'MM/DD/YYYY',
  'YYYY-MM-DD',
  'D MMMM YYYY',
  'DD MMM YYYY',
  'dddd D MMMM YYYY',
] as const;

export type DatePatternPreset = (typeof DATE_PATTERN_PRESETS)[number];
